import DashboardOpportunities from './DashboardOpportunities';

export * from './DashboardOpportunities';
export default DashboardOpportunities;
